import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = 'website',
  lang = 'tr',
  author = 'Akay Conseil'
}) => {
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : '';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const imageUrl = image ? (image.startsWith('http') ? image : `${siteUrl}/${image}`) : `${siteUrl}/img/logo-light.png`;

  // Default values
  const defaultTitle = 'Akay Conseil - Hukuk Danışmanlığı';
  const defaultDescription = 'Profesyonel hukuk danışmanlığı hizmetleri. İş hukuku, şirketler hukuku, aile hukuku ve daha fazlası için uzman ekibimizle iletişime geçin.';
  const defaultKeywords = 'hukuk, avukat, danışmanlık, iş hukuku, şirketler hukuku, aile hukuku, ceza hukuku, gayrimenkul hukuku';

  const seoTitle = title ? `${title} | Akay Conseil` : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <meta name="author" content={author} />
      <meta name="language" content={lang} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:locale" content={lang === 'tr' ? 'tr_TR' : lang === 'en' ? 'en_US' : lang === 'fr' ? 'fr_FR' : 'ku_IQ'} />
      <meta property="og:site_name" content="Akay Conseil" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={imageUrl} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
    </Helmet>
  );
};

export default SEO;

